import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { comparerByAlphabet } from '@app/comparers';

import {
  PlannerIdActionsUnion,
  PlannerIdActionTypes
} from '@core/actions/planner-id.actions';
import { PlannerId } from '@app/models/planner-id';

export interface State extends EntityState<PlannerId> {
  loading: boolean;
  loaded: boolean;
}

export const adapter: EntityAdapter<PlannerId> = createEntityAdapter<PlannerId>(
  {
    selectId: (plannerId: PlannerId) => plannerId,
    sortComparer: comparerByAlphabet('ASC')
  }
);

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: PlannerIdActionsUnion
) {
  switch (action.type) {
    case PlannerIdActionTypes.Load:
      return { ...state, loading: true };

    case PlannerIdActionTypes.LoadFail:
      return { ...state, loading: false };

    case PlannerIdActionTypes.LoadSuccess:
      return {
        ...state,
        loading: false,
        loaded: true
      };

    case PlannerIdActionTypes.AddAll:
      return adapter.addAll(action.plannerIds, state);

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
